/**
 * @generated SignedSource<<0d67ba97c6a2f79c8d168e321c559eb7>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type DisplayType = "LIST" | "TREE";
export type ObjectiveStatus = "ABANDONED" | "AT_RISK" | "BEHIND" | "COMPLETED" | "NO_STATUS" | "ON_TRACK";
export type ObjectivePaginationQuery$variables = {
  after?: string | null;
  archived?: boolean | null;
  assignedTo?: ReadonlyArray<string> | null;
  before?: string | null;
  cycles?: ReadonlyArray<string> | null;
  display?: DisplayType | null;
  first?: number | null;
  last?: number | null;
  node?: string | null;
  parent?: string | null;
  status?: ObjectiveStatus | null;
  title?: string | null;
};
export type ObjectivePaginationQuery$data = {
  readonly viewer: {
    readonly " $fragmentSpreads": FragmentRefs<"ObjectiveQueryViewer">;
  };
};
export type ObjectivePaginationQuery = {
  response: ObjectivePaginationQuery$data;
  variables: ObjectivePaginationQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "after"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "archived"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "assignedTo"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "before"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "cycles"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "display"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "first"
  },
  {
    "defaultValue": 50,
    "kind": "LocalArgument",
    "name": "last"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "node"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "parent"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "status"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "title"
  }
],
v1 = {
  "kind": "Variable",
  "name": "after",
  "variableName": "after"
},
v2 = {
  "kind": "Variable",
  "name": "before",
  "variableName": "before"
},
v3 = {
  "kind": "Variable",
  "name": "first",
  "variableName": "first"
},
v4 = {
  "kind": "Variable",
  "name": "last",
  "variableName": "last"
},
v5 = [
  (v1/*: any*/),
  {
    "kind": "Variable",
    "name": "archived",
    "variableName": "archived"
  },
  {
    "kind": "Variable",
    "name": "assignedTo",
    "variableName": "assignedTo"
  },
  (v2/*: any*/),
  {
    "kind": "Variable",
    "name": "cycles",
    "variableName": "cycles"
  },
  {
    "kind": "Variable",
    "name": "display",
    "variableName": "display"
  },
  (v3/*: any*/),
  (v4/*: any*/),
  {
    "kind": "Variable",
    "name": "node",
    "variableName": "node"
  },
  {
    "kind": "Variable",
    "name": "parent",
    "variableName": "parent"
  },
  {
    "kind": "Variable",
    "name": "status",
    "variableName": "status"
  },
  {
    "kind": "Variable",
    "name": "title",
    "variableName": "title"
  }
],
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "title",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "visibility",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "dueDate",
  "storageKey": null
},
v10 = [
  (v6/*: any*/),
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "email",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "image",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "fullName",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "isGuest",
    "storageKey": null
  }
],
v11 = {
  "alias": null,
  "args": null,
  "concreteType": "User",
  "kind": "LinkedField",
  "name": "assigneeUser",
  "plural": false,
  "selections": (v10/*: any*/),
  "storageKey": null
},
v12 = [
  (v6/*: any*/),
  (v7/*: any*/)
],
v13 = {
  "alias": null,
  "args": null,
  "concreteType": "Team",
  "kind": "LinkedField",
  "name": "assigneeTeam",
  "plural": false,
  "selections": (v12/*: any*/),
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "concreteType": "User",
  "kind": "LinkedField",
  "name": "contributors",
  "plural": true,
  "selections": (v10/*: any*/),
  "storageKey": null
},
v15 = {
  "alias": null,
  "args": null,
  "concreteType": "Team",
  "kind": "LinkedField",
  "name": "contributorsTeams",
  "plural": true,
  "selections": (v12/*: any*/),
  "storageKey": null
},
v16 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "description",
  "storageKey": null
},
v17 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "status",
  "storageKey": null
},
v18 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "archived",
  "storageKey": null
},
v19 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "weight",
  "storageKey": null
},
v20 = {
  "alias": null,
  "args": null,
  "concreteType": "Cycle",
  "kind": "LinkedField",
  "name": "cycle",
  "plural": false,
  "selections": [
    (v6/*: any*/)
  ],
  "storageKey": null
},
v21 = {
  "alias": null,
  "args": null,
  "concreteType": "Objective",
  "kind": "LinkedField",
  "name": "parent",
  "plural": false,
  "selections": [
    (v6/*: any*/),
    (v7/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "level",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Cycle",
      "kind": "LinkedField",
      "name": "cycle",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "startDate",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "endDate",
          "storageKey": null
        },
        (v6/*: any*/)
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v22 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "progress",
  "storageKey": null
},
v23 = {
  "alias": null,
  "args": null,
  "concreteType": "KeyResult",
  "kind": "LinkedField",
  "name": "keyResults",
  "plural": true,
  "selections": [
    (v6/*: any*/),
    (v7/*: any*/),
    (v9/*: any*/),
    (v11/*: any*/),
    (v13/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "metricProgress",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "metricType",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "metricCurrency",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "metricStart",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "metricCurrent",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "metricTarget",
      "storageKey": null
    },
    (v19/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "order",
      "storageKey": null
    },
    (v22/*: any*/)
  ],
  "storageKey": null
},
v24 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "hasAccess",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ObjectivePaginationQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "args": [
              (v1/*: any*/),
              (v2/*: any*/),
              (v3/*: any*/),
              (v4/*: any*/)
            ],
            "kind": "FragmentSpread",
            "name": "ObjectiveQueryViewer"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ObjectivePaginationQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v5/*: any*/),
            "concreteType": "ObjectivesConnection",
            "kind": "LinkedField",
            "name": "objectives",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "ObjectivesEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Objective",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v6/*: any*/),
                      (v7/*: any*/),
                      (v8/*: any*/),
                      (v9/*: any*/),
                      (v11/*: any*/),
                      (v13/*: any*/),
                      (v14/*: any*/),
                      (v15/*: any*/),
                      (v16/*: any*/),
                      (v17/*: any*/),
                      (v18/*: any*/),
                      (v19/*: any*/),
                      (v20/*: any*/),
                      (v21/*: any*/),
                      (v22/*: any*/),
                      (v23/*: any*/),
                      (v24/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Objective",
                        "kind": "LinkedField",
                        "name": "children",
                        "plural": true,
                        "selections": [
                          (v6/*: any*/),
                          (v7/*: any*/),
                          (v8/*: any*/),
                          (v9/*: any*/),
                          (v11/*: any*/),
                          (v13/*: any*/),
                          (v14/*: any*/),
                          (v15/*: any*/),
                          (v16/*: any*/),
                          (v17/*: any*/),
                          (v18/*: any*/),
                          (v19/*: any*/),
                          (v20/*: any*/),
                          (v21/*: any*/),
                          (v22/*: any*/),
                          (v23/*: any*/),
                          (v24/*: any*/)
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "__typename",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "cursor",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "PageInfo",
                "kind": "LinkedField",
                "name": "pageInfo",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "endCursor",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "hasNextPage",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "hasPreviousPage",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "startCursor",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": (v5/*: any*/),
            "filters": [
              "parent",
              "node",
              "display",
              "title",
              "status",
              "archived",
              "assignedTo",
              "cycles"
            ],
            "handle": "connection",
            "key": "ObjectiveQuery_objectives",
            "kind": "LinkedHandle",
            "name": "objectives"
          },
          (v6/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "904450a46865472bd61a9e7d8edeac9b",
    "id": null,
    "metadata": {},
    "name": "ObjectivePaginationQuery",
    "operationKind": "query",
    "text": "query ObjectivePaginationQuery(\n  $after: String\n  $archived: Boolean\n  $assignedTo: [ID!]\n  $before: String\n  $cycles: [ID!]\n  $display: DisplayType\n  $first: Int\n  $last: Int = 50\n  $node: ID\n  $parent: ID\n  $status: ObjectiveStatus\n  $title: String\n) {\n  viewer {\n    ...ObjectiveQueryViewer_pbnwq\n    id\n  }\n}\n\nfragment ObjectiveQueryViewer_pbnwq on Viewer {\n  objectives(parent: $parent, node: $node, display: $display, title: $title, status: $status, archived: $archived, assignedTo: $assignedTo, cycles: $cycles, before: $before, after: $after, first: $first, last: $last) {\n    edges {\n      node {\n        id\n        title\n        visibility\n        dueDate\n        assigneeUser {\n          id\n          email\n          image\n          fullName\n          isGuest\n        }\n        assigneeTeam {\n          id\n          title\n        }\n        contributors {\n          id\n          email\n          image\n          fullName\n          isGuest\n        }\n        contributorsTeams {\n          id\n          title\n        }\n        description\n        status\n        archived\n        weight\n        cycle {\n          id\n        }\n        parent {\n          id\n          title\n          level\n          cycle {\n            startDate\n            endDate\n            id\n          }\n        }\n        progress\n        keyResults {\n          id\n          title\n          dueDate\n          assigneeUser {\n            id\n            email\n            image\n            fullName\n            isGuest\n          }\n          assigneeTeam {\n            id\n            title\n          }\n          metricProgress\n          metricType\n          metricCurrency\n          metricStart\n          metricCurrent\n          metricTarget\n          weight\n          order\n          progress\n        }\n        hasAccess\n        children {\n          id\n          title\n          visibility\n          dueDate\n          assigneeUser {\n            id\n            email\n            image\n            fullName\n            isGuest\n          }\n          assigneeTeam {\n            id\n            title\n          }\n          contributors {\n            id\n            email\n            image\n            fullName\n            isGuest\n          }\n          contributorsTeams {\n            id\n            title\n          }\n          description\n          status\n          archived\n          weight\n          cycle {\n            id\n          }\n          parent {\n            id\n            title\n            level\n            cycle {\n              startDate\n              endDate\n              id\n            }\n          }\n          progress\n          keyResults {\n            id\n            title\n            dueDate\n            assigneeUser {\n              id\n              email\n              image\n              fullName\n              isGuest\n            }\n            assigneeTeam {\n              id\n              title\n            }\n            metricProgress\n            metricType\n            metricCurrency\n            metricStart\n            metricCurrent\n            metricTarget\n            weight\n            order\n            progress\n          }\n          hasAccess\n        }\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n      hasPreviousPage\n      startCursor\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "97788db235248a9f394c8b48363d9ef1";

export default node;
